module.exports = __webpack_public_path__ + "img/map_1791455919430_64100.c9fd82b9.gif";